import { NgModule } from '@angular/core';
import { DynamicReportBubleChartModule } from '../../shared/dynamic-report/buble-chart/buble-chart.module';
import { DynamicReportPieChartModule } from '../../shared/dynamic-report/pie-chart/pie-chart.module';
import { BaseModule } from '../../shared/base.module';

import { MeDynamicReportComponent } from './dynamic-report.component';
import { MeDynamicReportRoutesModule } from './dynamic-report.routes';
import { MeDynamicOverviewCardComponent } from './overview-card/overview-card.component';
import { MeDynamicClusterComponent } from './cluster/cluster.component';
import { MeDynamicSubClusterComponent } from './sub-cluster/sub-cluster.component';
import { MeDynamicOnboardingComponent } from './onboarding/onboarding.component';
import {RoundProgressModule} from 'angular-svg-round-progressbar';

@NgModule({
    imports: [
        BaseModule,
        RoundProgressModule,
        DynamicReportBubleChartModule,
        DynamicReportPieChartModule,
        MeDynamicReportRoutesModule
    ],
    declarations: [
        MeDynamicOnboardingComponent,
        MeDynamicClusterComponent,
        MeDynamicSubClusterComponent,
        MeDynamicReportComponent,
        MeDynamicOverviewCardComponent
    ],
    exports: [
        MeDynamicOnboardingComponent,
        MeDynamicClusterComponent,
        MeDynamicSubClusterComponent,
        MeDynamicReportComponent,
        MeDynamicOverviewCardComponent
    ]
})

export class MeDynamicReportModule { }
